module.exports = __webpack_public_path__ + "img/email.9866ebe8.png";